
const products = [
    {
        id: "1",
        name: "Fashion Business",
        price: "7.68",
        imageURL: "../images/Leather Shoes/ls01.webp",
        qty: 1
    },

    {
        id: "2",
        name: "Curren Men",
        price: "14.69",
        imageURL: "../images/wristwatches/ww01.webp",
        qty: 1
    },

    {
        id: "3",
        name: "Top Sport",
        price: "22.18",
        imageURL: "../images/sneakers/sneakers01.webp",
        qty: 1
    },

    {
        id: "4",
        name: "Autumn Men",
        price: "22.51",
        imageURL: "../images/Leather Shoes/ls02.webp",
        qty: 1
    },

    {
        id: "5",
        name: "OutDoor Sneakers",
        price: "12.69",
        imageURL: "../images/sneakers/sneakers04.webp",
        qty: 1
    },

    {
        id: "6",
        name: "Breathable Mesh",
        price: "13.49",
        imageURL: "../images/sneakers/sneakers03.webp",
        qty: 1
    },

    {
        id: "7",
        name: "EliteMen Quartz",
        price: "17.99",
        imageURL: "../images/wristwatches/ww02.webp",
        qty: 1
    },

    {
        id: "8",
        name: "Classic Lux",
        price: "6.13",
        imageURL: "../images/Leather Shoes/ls05.webp",
        qty: 1
    },

    {
        id: "9",
        name: "CRRJU Luxury",
        price: "17.99",
        imageURL: "../images/wristwatches/ww03.webp",
        qty: 1
    },

    {
        id: "10",
        name: "HandMade Leather",
        price: "22.11",
        imageURL: "../images/Leather Shoes/ls04.webp",
        qty: 1
    },

    {
        id: "11",
        name: "Top Mesh",
        price: "6.64",
        imageURL: "../images/sneakers/sneakers06.webp",
        qty: 1
    },

    {
        id: "12",
        name: "Men Watch",
        price: "12.59",
        imageURL: "../images/wristwatches/ww04.webp",
        qty: 1
    },

]

export default products